var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$apollo.loading)?_c('v-autocomplete',{attrs:{"items":_vm.power_plants,"item-text":"name","prepend-icon":"flash_on","label":"Planta","v-model":_vm.power_plant || {},"return-object":"","rules":[(v) => !!v || 'Selecione a Planta que desejada']}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }